
<title>Tv Owner Home</title>
<style>

.Brite_Stick_Class {
  background: #8DE5D0;
  cursor: pointer;
  
}

.Profile_Class {
  background: #59B5BD;
  cursor: pointer;
}

.NewScreen_Class {
  cursor: pointer;
  background: #8DE5D0;
}

.View_Bids_Class {
  background: #AEDEE3;
  cursor: pointer;

}
.spacer {
width: 100%;
height: 1px;
}

.header {
  position: relative;
  z-index: 100;
  color: #FFF;
  font-weight: bold;
}


</style>

<script>
import { Col, Container, Row } from "sveltestrap";

function changeToViewBids () {
	window.location.href = "#/brite-host/view_bids"
}
function changeToProfile () {
  window.location.href = "#/brite-host/profile"
}

function changeToManageGroups () {
  window.location.href = "#/brite-host/manage-groups"
  // window.location.href = "#/brite-host/setupbritestick"
}
function changeToNewScreen() {
    window.location = `#/brite-host/setup-britestick`
}

export function init() {}
</script>
<Container>
  <div class="Page_Title">
  <span>Welcome, {window.getBusinessName()}</span>
  </div>
</Container>
<Container>
  <Row class="justify-content-center">
    <Col sm="4" xs="8">
      <div class="Brite_Stick_Class Home_Actions" on:click = {changeToManageGroups}>
        <div class="header">Manage Screens</div>
        <img src="static/icons/TV_Spot_Location_A0_Rectangle_7_pattern.png" alt="Set Up Brite Stick">
      </div>
    </Col>
    <Col sm="4" xs="8">
        <div class="Home_Actions NewScreen_Class" on:click={changeToNewScreen}>
            <div class="header">New Screen</div>
            <img style="max-height: 90%; padding: 5%;" src="static/icons/New_Plus_Sign.png" class="new_screen" alt="New Screen"/>
        </div>
    </Col>
    <Col sm="4" xs="8">
      <div class= "Profile_Class Home_Actions" on:click ={changeToProfile}>
        <div class="header">Profile</div>
        <img style="max-height: 90%" src="static/icons/ProfileWhite_A0_Rectangle_3_pattern.png" alt="Profile">
      </div>
    </Col>
  </Row>
</Container>

    <!-- <div class="View_Bids_Class Home_Actions" on:click={changeToViewBids}>
      <div class="header">View Bids</div>
      <div>
      <img style="width: 100%;"src="static/icons/WhiteDollar_A0_Rectangle_7_pattern.png" alt="View Bids">
      </div>
    </div> -->